module.exports = __webpack_public_path__ + "static/media/clhs-logo-light.94dcbe73.png";